import { render, staticRenderFns } from "./NewReporte.vue?vue&type=template&id=098847f4&scoped=true"
import script from "./NewReporte.vue?vue&type=script&lang=js"
export * from "./NewReporte.vue?vue&type=script&lang=js"
import style0 from "./NewReporte.vue?vue&type=style&index=0&id=098847f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098847f4",
  null
  
)

export default component.exports